import React from "react";
import RoadMap from "../../../ebusHomePics/road-map.png";
import * as Scroll from "react-scroll";

const ComingSoon = (props) => {
  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <div className="row">
      <div className="w-100 p-0">
        <div className="container w-100 h-100 d-flex align-items-center">
          <img src={RoadMap} className="h-100 w-100" />
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div
          className="container pt-5 bg-white landings-container"
        >
          <h2
            className="p-4 col-6 col-md-3"
            style={{ borderBottom: "2.3px solid #6dd06d" }}
          >
            <b>ایباس در کدام شهرها فعال است ؟</b>
          </h2>
          <span className="mt-10 mb-20" style={{ lineHeight: "30px" }}>
            ایباس به عنوان " اولین سامانه حمل و نقل هوشمند اتوبوسی " که در
            زمستان 1400 فعالیت خود را در مسیر" رشت به تهران " و " تهران به رشت "
            آغاز کرده است. در تلاش هستیم که به زودی فعالیت خود را در شهرهای
            مختلف گسترش دهیم تا مسافران اتوبوسی در تمام مراکز استان و شهرستان‌ها
            از خدمات ایباس بهره‌مند شوند.
          </span>
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div
          className="container pt-5 bg-white landings-container"
        >
          <h2
            className="p-4 col-6 col-md-4"
            style={{ borderBottom: "2.3px solid #6dd06d" }}
          >
            <b> استان‌ها و شهرهای تحت پوشش ایباس</b>
          </h2>
          <span
            className="mt-10 mb-20 d-flex flex-column"
            style={{ lineHeight: "30px", gap: "10px" }}
          >
            <span> استان گیلان ( شهررشت ) به استان تهران ( شهرتهران )</span>

            <span>استان تهران ( شهرتهران ) به استان گیلان ( شهررشت )</span>
          </span>
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div
          className="container pt-5 bg-white landings-container"
        >
          <span
            className="p-4 col-6 "
            style={{ borderBottom: "2.3px solid #6dd06d" }}
          >
            <b>
              استان‌ها و شهرهای که به زودی در آن‌جا شروع به فعالیت خواهد کرد
            </b>
          </span>
          <span
            className="mt-10 mb-20 d-flex flex-column"
            style={{ lineHeight: "30px", gap: "10px" }}
          >
            <span> استان زنجان ( شهرزنجان ) به استان تهران ( شهرتهران )</span>
            <span>استان اردبیل ( شهراردبیل ) به استان تهران ( شهرتهران )</span>
            <span>
              استان آذربایجان‌شرقی ( شهر تبریز ) به استان تهران ( شهرتهران )
            </span>
            و به زودی در سراسر ایران در #فصل_جدید_سفر
          </span>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
